/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { CommonActions, CommonFlowState, FormActionPipelines } from '@gh/builder-shared';
import { getDialogInitData } from '@gh/common-shared';
import { DialogInput, DialogService, FormMode, noAnswer, yesNoConfirmation } from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';
import { assign } from 'lodash';
import {
  EstimatingSalesTaxRateDetailsDialogConfig,
  EstimatingSalesTaxRatesTabBusinessService,
} from '../../resources/estimating-sales-tax-rates-tab-business.service';
import { SalesTaxRate } from '../../resources/estimating-sales-tax-rates-tab.model';
import { EstimatingSalesTaxRateFormState } from './estimating-sales-tax-rate-details-form.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  standalone: false,
  selector: 'gh-estimating-sales-tax-rate-details-dialog',
  templateUrl: 'estimating-sales-tax-rate-details-dialog.component.html',
  styleUrls: ['estimating-sales-tax-rate-details-dialog.component.scss'],
  providers: [EstimatingSalesTaxRatesTabBusinessService],
  viewProviders: [EstimatingSalesTaxRateFormState],
})
export class EstimatingSalesTaxRateDetailsDialogComponent implements DialogInput<EstimatingSalesTaxRateDetailsDialogConfig>, OnInit {
  input: EstimatingSalesTaxRateDetailsDialogConfig;
  salesTaxRate: SalesTaxRate;

  constructor(private pipelines: FormActionPipelines,
              private businessService: EstimatingSalesTaxRatesTabBusinessService,
              private commonActions: CommonActions,
              private dialogService: DialogService,
              public dialogRef: MatDialogRef<EstimatingSalesTaxRateDetailsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private dialogData: any,
              public form: EstimatingSalesTaxRateFormState) {

  }

  get title(): string {
    return {
      [FormMode.CreateMode]: 'lbl_str_create',
      [FormMode.EditMode]: 'lbl_str_edit',
      [FormMode.ViewMode]: 'lbl_str_view',
    }[this.form.mode];
  }

  ngOnInit(): void {
    const { salesTaxRate } = getDialogInitData(this.dialogData);
    const salesTaxRateId = this.input.id;
    this.salesTaxRate = salesTaxRate;

    this.form.build(salesTaxRate);

    if (salesTaxRateId) {
      this.form.setValue(salesTaxRate);
    }
  }

  onSubmit(): void {
    const flow = this.pipelines.process({
      execute: this.commonActions.execute((state: CommonFlowState<any>) =>
        this.businessService.save(state.value)),
      finish: (state: CommonFlowState<any>) => {
        this.dialogRef.close(state.value);
      },
    });

    flow.run({
      form: this.form,
      trigger: 'process',
      value: this.form.get('isDefault').disabled
        ? assign(this.form.value, { isDefault: this.salesTaxRate.isDefault })
        : this.form.value,
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  confirmDefaultTaxUpdate({ checked }: MatCheckboxChange): void {
    if (checked) {
      this.dialogService
        .confirmation(yesNoConfirmation('msg_str_change_default')).pipe(
        filter$(noAnswer))
        .subscribe(() => {
          this.form.get('isDefault').setValue(false);
        });
    }
  }
}
